module.exports = __webpack_public_path__ + "img/informe_detallado_evaluacion.825d600a.svg";